import { useCallback, useEffect } from 'react'

import { useAbortController } from 'core/ui/hooks/useAbortController'
import { useAsync } from 'core/ui/hooks/useAsync'

import { getShipperDetail } from '../use-cases/getShipperDetail'

export function useShipperDetail(uuid: string | undefined) {
  const { call, result, status, error, reset } = useAsync(getShipperDetail)
  const abortController = useAbortController([uuid])

  const fetchShipperDetail = useCallback(() => {
    if (!uuid) {
      reset()
      return
    }
    call(uuid, { signal: abortController.signal })
  }, [uuid, call, reset, abortController])

  useEffect(() => {
    fetchShipperDetail()
  }, [fetchShipperDetail])

  return {
    fetchShipperDetail,
    shipperDetail: result,
    status,
    error,
  }
}
